export default "__VITE_ASSET__827c31d7__"